<template>
  <ida-page-403 :locale="locale" product="PLAYERLIST" @click="handleClick" />
</template>

<script>
import i18n from '@/lang'
export default {
  name: 'iDalgo-Playerlist-403',
  computed: {
    locale () {
      return i18n.locale
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/iDalgo-403.vue